// extracted by mini-css-extract-plugin
export var documentation = "_lg-1";
export var menu = "_lg-0";